import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PausePresentationIcon(props: IconProps) {
    return <Icon {...props} iconKey={"pause_presentation"}/>
}
